import React, { useState, useEffect } from 'react';
import constant from '../StaticVariables.json';
import RankingTableWidget from '../widgets/RankingTableWidget';
import SSVtableWidget from '../widgets/SSVtableWidget';
import SSTtableWidget from '../widgets/SSTtableWidget';
import CAflag from '../images/Canada-flag.png';

const CaTablesComponent = ({ onSymbolClick }) => {

    const [caBullishRankingTableData, setCaBullishRankingTableData] = useState([]);
    const [caBullishRankingLoading, setCaBullishRankingLoading] = useState(true);

    const [caBearishRankingTableData, setCaBearishRankingTableData] = useState([]);
    const [caBearishRankingLoading, setCaBearishRankingLoading] = useState(true);

    const [caSstTableData, setCaSstTableData] = useState([]);
    const [caSstLoading, setCaSstLoading] = useState(true);

    useEffect(() => {

        const fetchCaBullishRankingData = async () => {
            try {

                const response = await fetch(`${constant.ApiBaseUrl}Ranking/canada-bullish`);
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                const data = await response.json();

                setCaBullishRankingTableData(data);
                setCaBullishRankingLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setCaBullishRankingLoading(false);
            }
        };

        const fetchCaBearishRankingData = async () => {
            try {

                const response = await fetch(`${constant.ApiBaseUrl}Ranking/canada-bearish`);
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                const data = await response.json();

                setCaBearishRankingTableData(data);
                setCaBearishRankingLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setCaBearishRankingLoading(false);
            }
        };

        const fetchCaSstData = async () => {
            try {

                const response = await fetch(`${constant.ApiBaseUrl}SST/canada`);
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                const data = await response.json();

                setCaSstTableData(data);
                setCaSstLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setCaSstLoading(false);
            }
        };

        fetchCaBullishRankingData();
        fetchCaBearishRankingData();
        fetchCaSstData();
    }, []);

    return (
        <div className="widget-card">
            <h4 style={{ textAlign: 'center' }}>Canada<img src={CAflag} style={{ maxWidth: '20px' }} /></h4>
            <p style={{paddingLeft : '1rem', paddingRight: '1rem' }}>In the table below, you can find the top ten bullish ranks of the Canadian stock market. By clicking the chart icon in the Chart column, the corresponding chart will be displayed in the chart above, which is expected to continue its upward trend in the coming days.</p>
            <div style={{ overflowX: 'auto' }}>
                <RankingTableWidget data={caBullishRankingTableData} sort={"Bullish"} loading={caBullishRankingLoading} onTrSymbolClick={onSymbolClick.setTrSymbol} />
            </div>
            <br></br>
            <p style={{paddingLeft : '1rem', paddingRight: '1rem' }}>In the table below, you can find the top ten bullish ranks of the Canadian stock market. By clicking the chart icon in the Chart column, the corresponding chart will be displayed in the chart above, which is expected to continue its upward trend in the coming days.</p>
            <div style={{ overflowX: 'auto' }}>
                <RankingTableWidget data={caBearishRankingTableData} sort={"Bearish"} loading={caBearishRankingLoading} onTrSymbolClick={onSymbolClick.setTrSymbol} />
            </div>
            <br></br>
            {/* <div style={{ overflowX: 'auto' }}>
                <SSTtableWidget data={caSstTableData} loading={caSstLoading} onTrSymbolClick={onSymbolClick.setTrSymbol} />
            </div> */}

            <h4 style={{textAlign: 'center'}}>For more detail, check <a href='https://ca.stocksearch.trade' target='blank'>ca.stocksearch.trade</a></h4>
        </div>
    );
}

export default CaTablesComponent;